<template>
  <div class="user-center">
    <a-menu @click="select" v-model="selectedKeys" mode="inline">
      <a-menu-item key="1">基本信息</a-menu-item>
      <a-menu-item key="2">安全设置</a-menu-item>
      <a-menu-item key="3">消息通知</a-menu-item>
    </a-menu>

    <!--用户信息-->
    <section class="info-box" v-if="itemKey==='1'">
      <x-addEdit
        class="info-form"
        :formList="userInfoList"
        :formKey="formKey"
        :addParam="addParam"
        :editParam="userEditParam"
        :detailParam="userdetailParam"
        :itemLayout="itemLayout"
      >
      </x-addEdit>

      <div class="avatar">
        <div class="avatar-box">
          <img :src="avatarUrl" alt="">
        </div>
        <a-upload
          :beforeUpload="beforeUpload"
          :customRequest="customRequest"
          :fileList="[]"
          v-bind="{ accept: $store.state.imgAccept }"
        >
          <a-button icon="upload" :loading="upLoading.loading">更换头像</a-button>
        </a-upload>
      </div>
    </section>

    <!--修改密码-->
    <x-addEdit
      v-if="itemKey==='2'"
      class="pwd-form"
      :formList="formList"
      :addParam="pwdAddParam"
      :editParam="editParam"
      :itemLayout="itemLayout"
    >
    </x-addEdit>
  </div>
</template>
<script>
import empty from '../../js/empty';
export default {
  name: 'userInfo',
  data () {
    return {
      fileData: '',
      userInfo: {},
      avatarUrl: '',
      selectedKeys: [],
      itemKey: '1',
      upLoading: { loading: false },
      itemLayout: {
        labelCol: { span: 5 },
        wrapperCol: { span: 9 }
      },
      formKey: {
        user_name: '',
        mobile: '',
        role_desc: '',
        true_name: '',
        sex: ''
      },
      userInfoList: [
        {
          label: '账号名',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['user_name', {rules: []}]
        },
        {
          label: '手机号',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['mobile', {rules: []}]
        },
        {
          label: '角色',
          inputType: 'text',
          options: [],
          placeholder: '',
          props: ['role_desc', {rules: []}]
        },
        {
          label: '真实姓名',
          inputType: 'input',
          options: [],
          placeholder: '请输入真实姓名',
          props: ['true_name', {
            validateTrigger: 'blur',
            rules: [{ min: 1, max: 20, message: '真实姓名为1-20个字' }]
          }]
        },
        {
          label: '性别',
          inputType: 'select',
          options: this.$store.state.sexList,
          placeholder: '请选择性别',
          props: ['sex', {rules: []}]
        }
      ],
      addParam: {
        reqHandle: this.userReqHandle
      },
      userEditParam: {
        url: '',
        resHandle: '' // this.editResHandle
      },
      userdetailParam: {
        url: 'user/user_info',
        resHandle: ''
      },

      formList: [
        {
          label: '旧密码',
          inputType: 'input',
          options: [],
          placeholder: '请输入旧密码',
          type: 'password',
          props: ['old_password', {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: '请输入旧密码' },
              { pattern: this.REG.passWord, message: this.MESSAGE.passWord }
            ]
          }]
        },
        {
          label: '新密码',
          inputType: 'input',
          options: [],
          placeholder: '请输入新密码',
          type: 'password',
          props: ['password', {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: '请输入新密码' },
              { pattern: this.REG.passWord, message: this.MESSAGE.passWord }
            ]
          }]
        },
        {
          label: '确认密码',
          inputType: 'input',
          options: [],
          placeholder: '请输入确认密码',
          type: 'password',
          props: ['repassword', {
            validateTrigger: 'blur',
            rules: [
              { required: true, message: '请输入确认密码' },
              { pattern: this.REG.passWord, message: this.MESSAGE.passWord }
            ]
          }]
        }
      ],
      pwdAddParam: {
        reqHandle: this.pwdReqHandle
      },
      editParam: {
        url: '/user/modify/password',
        resHandle: '' // this.editResHandle
      }
    };
  },
  watch: {
    itemKey (val) {
      this.$nextTick(() => {
        val === '1' && this.setUserInfo();
      });
    }
  },
  mounted () {
    if (this.$route.query.param === 'changePwd') {
      this.itemKey = '2';
      this.selectedKeys = ['2'];
    } else {
      this.itemKey = '1';
      this.selectedKeys = ['1'];
      this.setUserInfo();
    }
  },
  methods: {
    /* 设置用户信息值 */
    setUserInfo () {
      if (localStorage.userInfo && !Object.keys(this.userInfo).length) {
        this.userInfo = JSON.parse(localStorage.userInfo);
      }
      this.avatarUrl = this.userInfo.avatar_url;
      empty.$emit('setForm', this.userInfo);
    },
    /* 修改密码 */
    pwdReqHandle (parm) {
      this.$put({
        url: '/user/modify/password',
        params: parm
      }).then((res) => {
        this.$message.success('修改成功').then((res) => {
          empty.$emit('setCacheData');
        });
      });
    },
    /* 修改用户信息 */
    userReqHandle (param) {
      this.submitUserInfo(param);
    },
    submitUserInfo (param) {
      this.$put({
        url: '/user/user_info',
        params: param
      }).then(({data}) => {
        this.avatarUrl = data.avatar_url;
        this.setLocal('userInfo', { ...this.userInfo, ...data });
        this.$message.success('修改成功！').then((res) => {
          this.$router.go(-1);
        });
      });
    },
    /* 上传前钩子 */
    beforeUpload (file, fileList) {
      this.fileData = file;
      return true;
    },
    /* 自定义上传事件 */
    customRequest (e) {
      let formdata = new FormData();
      formdata.append('file', this.fileData);
      this.$post({
        url: '/ht_upload_avatar',
        params: formdata,
        btnLoading: this.upLoading,
        config: { headers: { 'Content-Type': 'multipart/form-data' } }
      }).then(({data}) => {
        this.submitUserInfo({ avatar_id: data });
      });
    },

    /* 详情返回处理 */
    userResHandle (res) {
      this.avatarUrl = res.avatar_url;
      return {};
    },
    /* 选择菜单 */
    select ({ item, key, selectedKeys }) {
      this.itemKey = key;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/userInfo/userInfo.vue